
const Fn = {    
    KafraEmployee:[{
            name: 'KafraEmployee',
            text: 'Hi Atlan, how can I help you today?'
        },{
            name: 'KafraEmployee',
            text: 'Sure! You are fully recovered! :)'
        },{
            name: 'KafraEmployee',
            text: 'You already look healthy, please coming again next time !^^'
    }],
    //talk, buy, buy success, buy failure, sell, sell success, sell failure
    ToolDealer:[{
            name: 'ToolDealer',
            text: 'Welcome, today is a shinny day~~~'
        },{
            name: 'ToolDealer',
            text: 'We`re selling the best potion in Prontera!'
        },{
            name: 'ToolDealer',
            text: 'Thank you $_$'
        },{
            name: 'ToolDealer',
            text: 'Hmm...You don`t have enough Zeny T_T'
        },{
            name: 'ToolDealer',
            text: 'What do you want to trade for ^^?'
        },{
            name: 'ToolDealer',
            text: 'Thanks! Here is your Zeny!'
        },{
            name: 'ToolDealer',
            text: '...You can`t sell this item -_-'
    }],
    //Welcome
    WeaponArmorDealer:[{
        name: '',
        text: 'Enter the Weapon and armor shop in Proterna'
    }],
    //talk, buy, buy success, buy failure, sell, sell success, sell failure
    WeaponDealer:[{
            name: 'WeaponDealer',
            text: 'Our shop sell the best weapon in Prontera, what can I get for you?'
        },{
            name: 'WeaponDealer',
            text: 'The swords are all well forged!'
        },{
            name: 'WeaponDealer',
            text: 'Thank you. Nice to do business with you.'
        },{
            name: 'WeaponDealer',
            text: 'You don`t have enough Zeny.'
        },{
            name: 'WeaponDealer',
            text: 'Huhh? What kind of equipment did you wanna sell?'
        },{
            name: 'WeaponDealer',
            text: 'Trading your weapons, here is your Zeny'
        },{
            name: 'WeaponDealer',
            text: 'This item is unique, I can`t take it @@'
    }],
    ArmorDealer:[{
            name: 'ArmorDealer',
            text: 'Hi Atlan, how are you today? :)'
        },{
            name: 'ArmorDealer',
            text: 'Here and take a look!'
        },{
            name: 'ArmorDealer',
            text: 'Nice Purchase xD'
        },{
            name: 'ArmorDealer',
            text: 'Your pocket doesn`t have enough Zeny. x_x'
        },{
            name: 'ArmorDealer',
            text: 'You want to sell something?'
        },{
            name: 'ArmorDealer',
            text: 'Ohh Great!! I`ll pay for all the armors'
        },{
            name: 'ArmorDealer',
            text: 'This item is unique, I can`t take it -.-'
    }],
    GarmentDealer:[{
            name: 'GarmentDealer',
            text: 'Fashion is Always a Reflection of the Time, But it is Forgotten If it is Foolish.'
        },{
            name: 'GarmentDealer',
            text: 'Please feel free to take a look ^^'
        },{
            name: 'GarmentDealer',
            text: 'Thank You~ Hope you like it!'
        },{
            name: 'GarmentDealer',
            text: 'T_T Not enough Zeny'
        },{
            name: 'GarmentDealer',
            text: 'I only interest on collecting garments >_<'
        },{
            name: 'GarmentDealer',
            text: 'Thanks :D I`ll give you back some Zeny!'
        },{
            name: 'GarmentDealer',
            text: 'You don`t want to sell this to me xD! I`m not accepting it'
    }],
        ShoesDealer:[{
            name: 'ShoesDealer',
            text: 'You can wear anything as long as you put a nice pair of shoes with it.'
        },{
            name: 'ShoesDealer',
            text: 'I have lots of good brand of shoes xD'
        },{
            name: 'ShoesDealer',
            text: 'The shoe size should fit with you :)'
        },{
            name: 'ShoesDealer',
            text: '@@ Require more Zeny to purchase my items!'
        },{
            name: 'ShoesDealer',
            text: 'Any old pair of shoes you don`t want?'
        },{
            name: 'ShoesDealer',
            text: 'Haha Thanks! I`ll collect them!'
        },{
            name: 'ShoesDealer',
            text: 'This item is unique, I won`t accept the trade!'
    }],
    //Welcome, talk, buy, buy success, buy failure, sell, sell success, sell failure
    //talk, buy, buy success, buy failure, sell, sell success, sell failure
    HeadGearDealer:[{
            name: 'HeadGearDealer',
            text: 'Hi Atlan! Nice to see you :)'
        },{
            name: 'HeadGearDealer',
            text: 'What do you want to buy?'
        },{
            name: 'HeadGearDealer',
            text: 'Here is your item ^^!'
        },{
            name: 'HeadGearDealer',
            text: 'You don`t have enough Zeny. ><'
        },{
            name: 'HeadGearDealer',
            text: 'What do you want to sell?'
        },{
            name: 'HeadGearDealer',
            text: 'Sure~ Here is your Zeny :D'
        },{
            name: 'HeadGearDealer',
            text: 'This item is not for sale =.='
    }],
    AccessoriesDealer:[{
            name: 'AccessoriesDealer',
            text: 'Accessories make everything better~'
        },{
            name: 'AccessoriesDealer',
            text: 'Buy anything you like for my accessories!'
        },{
            name: 'AccessoriesDealer',
            text: 'Thanks! :D'
        },{
            name: 'AccessoriesDealer',
            text: 'Not enough Zeny :O'
        },{
            name: 'AccessoriesDealer',
            text: 'I can collect those accessories :D'
        },{
            name: 'AccessoriesDealer',
            text: 'I`ll collect them for you, here is your zeny!'
        },{
            name: 'AccessoriesDealer',
            text: 'I can`t take this item O_O'
    }],
    SoldierGuard1:[{
            name: 'SoldierGuard',
            text: 'Welcome to Prontera! This is the Porntera Castle Enterance.'
        }],
    SoldierGuard2:[{
            name: 'SoldierGuard',
            text: 'My duty is to protect Prontera.'
        }],
    Kiwi:[{
            name: 'Kiwi',
            text: 'If you want to join my Assassin Guild, I will teach you my "Double Attack" skill.'
        },{
            name: 'Kiwi',
            text: 'Proof me that you want to join, If you can defeat the Blue rabbit - Eclipse in PoringIsland'
        },{
            name: 'Kiwi',
            text: 'You have learn "Double Attack"!!'
        },{
            name: 'Kiwi',
            text: 'Welcome to Our Assassin Guild - "Double Attack" will never fails you'
        }],
    Lemon:[{
            name: 'Lemon',
            text: 'Lemonekko Guild recruiting some tanky class, Our best strategy is defence and reflect &bsol; . /'
        },{
            name: 'Lemon',
            text: 'Hehehe I wounder if you can defeat boss - Wolyafa first, She kept summoning her monsters in PayonCave, then you will be granted to join us.'
        },{
            name: 'Lemon',
            text: 'You have learn "Reflect Attack"!!'
        },{
            name: 'Lemon',
            text: 'The monster will get to pay their price if they hit me hard - That`s how I teach my Lemonekko Guild'
        },{
            name: 'Lemon',
            text: 'Sigh.. Yeah I draw some of them but how dare you can find the other drawings?'
        },{
            name: 'Lemon',
            text: 'This will be a part of my memory...(tears) Thanks for bring all back to me Atlan..'
        }],
    Chocolate:[{
            name: 'Chocolate',
            text: 'I am a Summoner and love my little dog - Kobi Guild, Stay alive during the battle is our best bet! :)'
        },{
            name: 'Chocolate',
            text: 'I wonder if you could help me to find the items - 7 of Skel-Bone and a Old Portrait, I will be appricate and let you join in ^^.'
        },{
            name: 'Chocolate',
            text: 'You have learn "LifeSteal Attack"!!'
        },{
            name: 'Chocolate',
            text: 'Kobi Guild - My little Dog Kobi loves to meet you ^^~. #corgi.kobi'
        }],
    PronteraKing:[{
            name: 'Prontera King',
            text: 'Atlan, you need to collect all three important items to seal the chaos gate. Please hurry!'
        },{
            name: 'Prontera King',
            text: 'The Chaos gate is already opened.. Atlan you take down the Baphomet and save our city!!'
        },{
            name: 'Prontera King',
            text: 'The Gate is sealed, our country will live in a peaceful generations without evil monsters, thanks Atlan!'
        }],
    PronteraAssistant:[{
            name: 'PronteraAssistant',
            text: 'I`m doing a research now, please don`t distrub me.'
        },{
            name: 'PronteraAssistant',
            text: 'I can create a magic amulet that allows to regenerate your wounds when you are defending, but I need 1 RedGemstone, 10 CursedRubies,and 2 Diamonds to create it'
        },{
            name: 'PronteraAssistant',
            text: 'You have learn Amulet Recovery!!'
        },{
            name: 'PronteraAssistant',
            text: 'Thanks for helping my research o_o, hope the amulet will guide you to success~'
        }],
    RoyalGuard1:[{
            name: 'RoyalGuard',
            text: 'Royal guard is different than soldier guard, mainly we are more well trained to protect our king.'
        }],
    RoyalGuard2:[{
            name: 'RoyalGuard',
            text: 'I will serve my Prontera King.'
        }],
    RestingGirl:[{
            name: 'RestingGirl',
            text: 'Rumors saids there is a hidden passage near by here...hmm where is it?',
        },{
            //Hidden Path?
            name: 'RestingGirl',
            text: 'Use <span style="color:red;">Lamp</span> in item menu can forsee the unknown path~ :)'
        },{
            //who are you?
            name: 'RestingGirl',
            text: 'I`m just a girl and I like to collect 3 <span style="color:red;">Jellopy</span> and a <span style="color:red;">Empty Bottle</span>.. ⛦◜▿◝'
        },{
            //Give 3 Jellopy & 3 Empty Bottle
            name: 'RestingGirl',
            text: 'You are my hero!! I love you(*°ヮ° *) <p style="color:#3fff00;">Recieved +100exp +3000z</p>'
        }],
    MightyGuy:[{
            name: 'MightyGuy',
            text: 'I`m here because I can train you to be a stronger knight. Select your training and I see if you can pass the test.'
        },{
            name: 'MightyGuy',
            text: 'Master yourself, master the enemy'
        }],
    Atlan:[{
        //PayonCave2F self
            name: 'Atlan',
            text: 'This place is dark.'
        },{
            name: 'Atlan',
            text: 'Wow! I can see another path!'
        },{
            name: 'Atlan',
            text: 'A story from Lemon: "Warcraft 3 Illidan, and I have draw his picture because he is so cool!! - Lemon 2015" (Hidden Story 1/3)'
        },{
            name: 'Atlan',
            text: 'A story from Lemon: "Back into the days where we watch "Spirited Away" in 2001 - Lemon 2016" (Hidden Story 2/3)'
        },{
            name: 'Atlan',
            text: 'A story from Lemon: "Toradora! - Taiga & Ryuji funny couple ^^" (Hidden Story 3/3)'
        },{
            name: 'Atlan',
            text: 'Hmm.. I have to better find the other pieces before I come back here.'
        },{
        //GeffenDungeon
            name: 'Atlan',
            text: 'This dungeon has been forfeit for a long time, surrounded by all evil demons...'
        },{
            name: 'Atlan',
            text: 'Who is standing there? And he is suddenly disappear..?'
        }],
    Adventure:[{
            name: 'Adventure',
            text: 'Bongun & Munak are lovers even when they are turn into zombie, how tragedy it is..'
        }],
    ScaredAcolyte:[{
            name: 'ScaredAcolyte',
            text: 'OMG! This place is freaking me out, I wanna leave now T^T...'
        }],
    Nia:[{
            name: 'Nia',
            text: 'I wish I could get a Doppelganger card, because of the attack speed buff and he is charming >﹏<'
        },{
            name: 'Nia',
            text: 'Careful there is a big monster ahead!! I`m better get going!'
        }],
    Reki:[{
            name: 'Reki',
            text: '-(Wish you luck)-'
        }],
    GoblinYula:[{
        name: 'Goblin Yula',
        text: 'Once before Geffen is a Wizard city, trained to be a Magician first :)'
    },{
        name: 'Goblin Yula',
        text: 'If you finish my Challenge and give me the stone, you can learn how to use item faster during the battle...'
    },{
        name: 'Goblin Yula',
        text: 'You have learn "Master Item"!!'
    },{
        name: 'Goblin Yula',
        text: 'Let`s Celerbrate our Master Item skills :D!'
    }],
    GeffenCitizen:[{
        name: 'Citizen',
        text: 'Being a mage is hard, Passing the test to be wizard is almost impossible.'
    },{
        name: 'Citizen',
        text: 'The rarest head gear is Lord Kahos Horn, it is nearly impossible to get it...'
    }],
    GeffenTimer:[{
        name: 'GeffenTimer',
        text: 'You need to be always prepared, because the chance can be pop up in anytime.'
    }],
    GeffenGrandma:[{
        name: 'GeffenGrandma',
        text: 'Atlan, I hope you notice to give it out all your best when there is a chance. Just give it all out with no regrets like me'
    }],
    GeffenSoldier:[{
        name: 'GeffenSoldier',
        text: 'Please be mindful of Geffen Dungeon, the monster are cursed , brutal and aggressive. Be aware and prepared ^^!'
    }],
    Fairy:[{
    //PoringIsland
        name: 'Fairy',
        text: 'Hi Atlan, I`m Fairy :). follow me! there is a shop there might help your journey Atlan!'
    },{
        name: 'Fairy',
        text: 'This way!'
    },{
    //PayonCave
        name: 'Fairy',
        text: 'Atlan, look at the lake, it seems like this place might have some hidden path!'
    },{
        // Hidden path on PayonCave..?
        name: 'Fairy',
        text: 'Yes yes yes I know ~@@, there are <span style="color:red;">two</span> hidden paths on Payon Cave, The first one is on <span style="color:red;">1F</span>, I`m sure you could find the second one :)'
    },{
        // Hidden path on GeffenDungeon..?
        name: 'Fairy',
        text: 'that place is strange.. You should find a way to enter the center of the map on <span style="color:red;">2F</span>, also there is a <span style="color:red;">hidden treasure</span> hiding somewhere on GeffenDungeon o_o.'
    }],
}

const npcSpeechReducer = (state = Fn, action) => {
    switch(action.type){
        default:
            return state;
    }
}

export default npcSpeechReducer;